var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('queue-receiver',{staticClass:"notifications",attrs:{"ns":"notify","transition":_vm.transition},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var data = ref.data;
var close = ref.close;
return [_c('notification',_vm._b({on:{"close":close}},'notification',data,false))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }